export enum LookupTypes {
  speciality = 'speciality',
  industry = 'vendor-industry',
}

export interface LookupItem {
  id: number
  name: string
  slot?: number
  description?: string
  slug?: string
  tagline?: string
}
